import { observer } from 'mobx-react-lite'
import { Button, DropdownContent, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { type IUser } from 'entities/Users/model/types'
import { UsersDropdownContentItems } from 'widgets/SearchDropdown/ui/DropdownContent/UsersDropdownContent/UsersDropdownContentItems'
import { type SearchDropdownUsersStore } from 'widgets/SearchDropdown/store/searchDropdownUsersStore'
import styles from './styles.module.scss'

type IUsersDropdownContentProps = {
  store: SearchDropdownUsersStore
  onChange?: (item: IUser) => void
  width?: number
}

export const UsersDropdownContent = observer(
  ({ store, onChange, width }: IUsersDropdownContentProps) => {
    const { search, handleSearch, placeholder, hasSelectedItems, resetType, init, maxLimit } = store

    const handleReset = () => {
      resetType()
      init()
    }

    return (
      <DropdownContent noPadding className={styles.wrap} width={width}>
        <div className={styles.searchWrap}>
          <TextField
            className={styles.search}
            variant='integrated'
            InputProps={{
              placeholder: placeholder,
            }}
            onChange={handleSearch}
            value={search}
            mainActions={[makeTextFieldAutoFocus({ withFocus: !search })]}
          />
        </div>
        {maxLimit && (
          <Typography
            variant='body-sm-medium'
            color='var(--content-primary-tertiary)'
            ariaLabel='MembersDropdownLimit'
            className={styles.limitInfo}
          >
            Select members (up to {maxLimit})
          </Typography>
        )}
        <UsersDropdownContentItems store={store} onChange={onChange} />

        {hasSelectedItems && (
          <div className={styles.clear}>
            <Button typeBtn={'text'} text={'Clear'} onClick={handleReset} />
          </div>
        )}
      </DropdownContent>
    )
  }
)
